<template>
  <div v-loading="listContentLoading">
    <el-button
      style="padding: 0; margin: 20px;"
      type="text"
      icon="el-icon-back"
      @click="$router.go(-1)"
    >
      返回
    </el-button>

    <el-input
      class="search-el"
      size="mini"
      v-model="query.search"
      clearable
      placeholder="请输入用户昵称/手机号"
    ></el-input>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.order_source"
      clearable
      placeholder="订单来源"
    >
      <el-option label="全部" value="">全部</el-option>
      <el-option label="灵动生活APP" value="app">灵动生活APP</el-option>
      <el-option label="灵动生活H5" value="h5">灵动生活H5</el-option>
      <el-option label="抖音" value="backend_activity_import_dy"
        >抖音</el-option
      >
      <el-option label="小鹅通" value="xiaoetong">小鹅通</el-option>
      <el-option label="视频号" value="backend_activity_import_wxvideo"
        >视频号</el-option
      >
    </el-select>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.cashback_status"
      clearable
      placeholder="返现状态"
    >
      <el-option label="全部" value="0">全部</el-option>
      <el-option label="未返现" value="1">未返现</el-option>
      <el-option label="已返现" value="2">已返现</el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getCertStudentList()"
      >查询</el-button
    >
    <el-button type="primary" size="mini" @click="updateCashBackStatus()"
      >批量修改为已返现</el-button
    >
    <el-button type="primary" size="mini" @click="exportCert()">
      导出
    </el-button>
    <el-row>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="checkboxSelect"> </el-table-column>

        <el-table-column
          prop="nickname"
          label="昵称"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="mobile_phone"
          label="手机号"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="order_no"
          label="订单号"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="created_at"
          label="下单时间"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="source_msg"
          label="订单来源"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="cashback_status_msg"
          label="返现状态"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
            prop="total_amount"
            label="返现金额"
            align="center"
            min-width="8%"
        ></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getCertStudentList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getCertStudentList, updateCashBackStatus } from "@/api/clockIn";
const axios = require('axios');

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        attendance_id: this.$route.query.attendance_id,
        search: "",
        order_source: "",
        cashback_status: "0",
        is_export: 0,
      },

      listContentLoading: false,

      multipleSelection: [],
    };
  },
  created: function () {
    this.getCertStudentList();
  },
  methods: {
    getCertStudentList() {
      this.loading = true;
      getCertStudentList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    checkboxSelect(row) {
        return row.cashback_status == 2 ? 1 : 0;
    },

    handleSelectionChange(val) {
        this.multipleSelection = val;
    },

    updateCashBackStatus() {
        var ids = [];
        this.multipleSelection.map(function (item) {
            ids.push(item.id);
        });
        updateCashBackStatus({
            attendance_id: this.$route.query.attendance_id,
            ids: ids
        }).then((response) => {
        if (response.status == 2000) {          
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
          this.getCertStudentList();
        } /*else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }*/
      });
    },
    //导出
    exportCert() {
      this.query.is_export = 1;
      Object.assign(this.query,this.$route.query)
      console.log(this.query);
      /*if (this.query.is_export > 0) {*/
      axios({
        method: "post",
        url: "/backend/ClockIn/getCertStudentList",
        data: this.query,
        responseType: "blob",
      })
          /*getOrderList(this.query)*/.then((res) => {
        //console.log(res)
        const link = document.createElement("a");
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "打卡返现列表.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.query.is_export = 0;
      })
          .catch((error) => {
            this.$Notice.error({
              title: "错误",
              desc: "网络连接错误",
            });
            console.log(error);
          });
      /*}*/
    },
  },
  mounted() {},
};
</script>
